import { populateCareers, getCareerResults, getAllBookmarks, getBookmarks, createBookmark, deleteBookmark, getCareerUsingUuid, getProgramGuideUsingUuid, getCareerInformation, getCareerResultsUsingSocCode, getProgramCreditProgress, getCareerSkillProgress, getFastestGrowingCareers, getCareersWithLargestEmployment, getReport, getInstitutionCareers } from '../api'
import { buildNameSearchQuery, buildBaseQuery, buildOrQuery, getInstitutionIdFilter, getUpdatedFacet } from '../../search/searchUtils'
import { getResults } from '../../search/api'

export const loadAllBookmarks = ({ state, commit }) => {
  return getAllBookmarks().then(res => {
    commit('LOAD_BOOKMARKS', res)
    return res
  })
}

export const loadBookmarks = ({ state, commit }, {name, page, count}) => {
  return getBookmarks(name, page, count).then(res => {
    commit('LOAD_BOOKMARKS', res)
    return res
  })
}

export const loadCreateBookmarks = ({ state, commit }, bookmark) => {
  return createBookmark(bookmark)
}

export const loadDeleteBookmark = ({ state, commit }, bookmarkId) => {
  return deleteBookmark(bookmarkId)
}

export const loadCareerUsingUuid = ({ state, commit }, uuid) => {
  return getCareerUsingUuid(uuid)
}

export const loadProgramGuideUsingUuid = ({ state, commit }, uuid) => {
  return getProgramGuideUsingUuid(uuid).then(res => {
    return res
  })
}

export const loadCareersPivot = ({ state, commit }) => {
  return populateCareers().then(res => {
    commit('LOAD_CAREERS', res)
    return res
  })
}

export const loadCareerInformation = ({ state, commit }, { career, institutionId }) => {
  return getCareerInformation(career, institutionId)
}

export const loadCareerResults = ({ state, commit }, cipCode) => {
  return getCareerResults(cipCode).then(res => {
    commit('LOAD_CAREER_RESULTS', res)
    return res
  })
}

export const loadCareerResultsUsingSocCode = ({ state, commit }, socCode) => {
  return getCareerResultsUsingSocCode(socCode).then(res => {
    commit('LOAD_CAREER_RESULTS', res)
    return res
  })
}

export const setCurrentFacet = ({ state, commit }, currentFacet) => {
  commit('LOAD_CURRENT_FACET', currentFacet)
  return currentFacet
}

export const loadExploreResults = ({ state, commit }, data) => {
  if (data.indexList.length === undefined || data.libraryList.length === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    var hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    var processedHits = []
    for (var i = 0; i < hits.length; i++) {
      var result = {
        uuid: hits[i]._id,
        index: hits[i]._index,
        type: hits[i]._source.type,
        title: (hits[i]._source.title && hits[i]._source.title.length > 0) ? hits[i]._source.title : hits[i]._source.streamTitle,
        description: hits[i]._source.description,
        thumbnail: hits[i]._source.thumbnail,
        thumbnailURIList: hits[i]._source.thumbnailURIList,
        streamTitle: hits[i]._source.streamTitle,
        streamId: hits[i]._source.streamId,
        resourceType: hits[i]._source.type,
        entityType: (hits[i]._source.type) ? hits[i]._source.type.toUpperCase() : '',
        total: res.hits.total
      }
      processedHits.push(result)
    }
    return processedHits
  })
}

export const loadExploreSearchResults = ({ state, commit }, {data, resetFacets, facetNames, selectedFacetNames, currentFacetResults}) => {
  if (data.indexList.length === undefined || data.libraryList.length === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    let hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    let total = (res && res.hits && res.hits.total && res.hits.total.value) ? res.hits.total.value : 0
    let processedHits = []
    for (var i = 0; i < hits.length; i++) {
      let result = {
        uuid: hits[i]._source.uuid,
        index: hits[i]._index,
        resourceType: hits[i]._index,
        type: hits[i]._source.type,
        title: hits[i]._source.title,
        name: hits[i]._source.name,
        description: hits[i]._source.description,
        elasticSearchDocument: hits[i]._source
      }
      processedHits.push(result)
    }

    const inputState = {
      resetAllFacets: resetFacets === true,
      selectedFacetNames: selectedFacetNames,
      currentFacets: currentFacetResults || {},
      responseFacets: res.aggregations || {}
    }

    let formattedFacets = {}
    facetNames.forEach(facetName => {
      formattedFacets[facetName] = getUpdatedFacet(facetName, inputState)
    })

    const response = {
      total: total,
      hits: processedHits,
      facets: formattedFacets
    }
    return response
  })
}

export const searchForCareers = ({ state, commit }, {terms, sort, source, from, size, userId, facets, filter, facetNames, selectedFacetNames}) => {
  let query = terms && terms.length > 0 ? buildNameSearchQuery(terms) : buildBaseQuery()
  let elasticSearchRequest = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: query,
    aggs: facets
  }

  if (Object.keys(filter).length > 0) {
     elasticSearchRequest['post_filter'] = filter
   }

  let requestPayload = {
    'indexList': ['career'],
    'libraryList': [userId],
    'useDefaultFields': 'false',
    'payload': elasticSearchRequest
  }
  const params = {
    data: requestPayload,
    resetFacets: false,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames,
    currentFacetResults: state.careerFacetResults
  }
  return loadExploreSearchResults({ state, commit }, params).then(response => {
    commit('LOAD_CAREER_TOTAL', response.total)
    commit('UPDATE_CAREER_RESULTS', response.hits)
    commit('UPDATE_CAREER_FACET_RESULTS', response.facets)
    return response
  })
}

export const saveCareerSearchState = ({ state, commit }, {terms, sort, filter, selectedFacetNames, customIncomeMin, customIncomeMax, institutionCareerFilter}) => {
  commit('UPDATE_CAREER_SEARCH_TERMS', terms)
  commit('UPDATE_CAREER_SEARCH_SORT', sort)
  commit('UPDATE_CAREER_SEARCH_FILTER', filter)
  commit('UPDATE_CAREER_SEARCH_SELECTED_FACET_NAMES', selectedFacetNames)
  commit('UPDATE_CAREER_SEARCH_INCOME_MIN', customIncomeMin)
  commit('UPDATE_CAREER_SEARCH_INCOME_MAX', customIncomeMax)
  commit('UPDATE_CAREER_SEARCH_INSTITUTION_CAREER_FILTER', institutionCareerFilter)
}

export const resetCareerSearchState = ({ state, commit }) => {
  const params = {
    terms: '',
    sort: {},
    filter: {},
    selectedFacetNames: [],
    customIncomeMin: '',
    customIncomeMax: '',
    institutionCareerFilter: true
  }
  return saveCareerSearchState({ state, commit }, params)
}

export const loadProgramCreditProgress = ({ state, commit }, {streamId, programId, recalculate}) => {
  return getProgramCreditProgress(streamId, programId, recalculate)
}

export const loadCareerSkillProgress = ({ state, commit }, {streamId, careerId, recalculate}) => {
  return getCareerSkillProgress(streamId, careerId, recalculate)
}

export const loadFastestGrowingCareers = ({ state, commit }) => {
  return getFastestGrowingCareers()
}

export const loadCareersWithLargestEmployment = ({ state, commit }) => {
  return getCareersWithLargestEmployment()
}

export const searchForProgramGuides = ({ state, commit }, {terms, sort, source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, facets, filter, facetNames, selectedFacetNames}) => {
  const libraryFilter = getInstitutionIdFilter(publicLibraryList.concat(privateLibraryList))
  let query = {
    'constant_score': {
      'filter': buildOrQuery(libraryFilter),
      'boost': 1.0
    }
  }
  let filterByMajor = {
    'bool': {
      'must': [{
        'bool': {
          'should': [{
            'terms': {
              'type': ['major', 'minor', 'wft', 'cert', 'certificate']
            }
          }]
        }
      }]
    }
  }
  query.constant_score.filter.bool.must.push(filterByMajor)
  if (terms) {
    // query = buildOrQuery(libraryFilter)
    let queryString = {
      'query_string': {
        'query': 'TBA',
        'fields': ['title', 'description']
        // 'default_field': 'title'
      }
    }
    // Add wildcard to end of query
    queryString.query_string.query = (terms.split(',').join(' ') + '*')
    query.constant_score.filter.bool.must.push(queryString)
  }

  let elasticSearchRequest = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: query,
    aggs: facets
  }

  if (Object.keys(filter).length > 0) {
    elasticSearchRequest['post_filter'] = filter
  }

  let requestPayload = {
    'indexList': indexList,
    'libraryList': libraryList,
    'useDefaultFields': 'false',
    'payload': elasticSearchRequest
  }
  const params = {
    data: requestPayload,
    resetFacets: false,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames,
    currentFacetResults: state.programGuideFacetResults
  }
  return loadExploreSearchResults({ state, commit }, params).then(response => {
    commit('LOAD_PROGRAM_TOTAL', response.total)
    commit('UPDATE_PROGRAM_GUIDE_RESULTS', response.hits)
    commit('UPDATE_PROGRAM_GUIDE_FACET_RESULTS', response.facets)
    return response
  })
}

export const saveProgramGuideSearchState = ({ state, commit }, {terms, sort, filter, selectedFacetNames, customIncomeMin, customIncomeMax}) => {
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_TERMS', terms)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_SORT', sort)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_FILTER', filter)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_SELECTED_FACET_NAMES', selectedFacetNames)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MIN', customIncomeMin)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MAX', customIncomeMax)
}

export const resetProgramGuideSearchState = ({ state, commit }) => {
  const params = {
    terms: '',
    sort: {},
    filter: {},
    selectedFacetNames: [],
    customIncomeMin: '',
    customIncomeMax: ''
  }
  return saveProgramGuideSearchState({ state, commit }, params)
}

export const loadReport = ({ state, commit }, query) => {
  return getReport(query).then(res => {
    return res
  })
}

export const loadInstitutionCareers = ({ state, commit }) => {
  return getInstitutionCareers().then(res => {
    let codes = []
    res.forEach((item, i) => {
      codes.push(item.code)
    })

    commit('LOAD_INSTITUTION_CAREERS', codes)
    return res
  })
}



// WEBPACK FOOTER //
// ./src/app/explore/vuex/actions.js